export default __webpack_public_path__ + "static/media/andamento-icon.1b909207.svg";